module.exports = "/_next/static/images/game-1-phone-attachment-gift-98b24cf0c93d34df1113295a2207aa09.jpg";